<template>
    <div class="boxs" style="overflow: hidden">
        <div class="top_nav">
            <router-link to="/">
                <div class="nav1" id="topnav_box" style="/*border-bottom: 4rem solid #0E6EB8*/">
                    <span>企业简介</span>
                </div>
            </router-link>
            <router-link to="/business">
                <div class="nav2">
                    <span>业务范围</span>
                </div>
            </router-link>
            <router-link to="/boutique">
                <div class="nav3">
                    <span>精品工程</span>
                </div>
            </router-link>
        </div>
        <div class="top_nav2">
            <router-link to="/">
                <div class="nav1" id="topnav_box" style="border-bottom: 4rem solid #0e6eb8">
                    <span>企业简介</span>
                </div>
            </router-link>
            <router-link to="/business">
                <div class="nav2">
                    <span>业务范围</span>
                </div>
            </router-link>
            <router-link to="/boutique">
                <div class="nav3">
                    <span>精品工程</span>
                </div>
            </router-link>
        </div>

        <!-- <div class="top_nav">
            <div
                class="nav1"
                v-for="(item, index) in headerNav"
                :key="index"
                :class="{ Navactive: index }"
                @click="Navclick(index)"
            >
                <span>{{ item.name }}</span>
            </div>
        </div>
        <index v-if="result == 0"></index>
        <business v-if="result == 1"></business>
        <boutique v-if="result == 2"></boutique> -->

        <div class="video" style="position: relative; margin-bottom: 75rem">
            <div>
                <!-- <div class="video-fixed" v-if="videoshow">
                    <video
                        src="https://www.zjzhongtian.com/upload/2020/10/21/160324657453041imf2.mp4"
                        controls
                        width="100%"
                        height="100%"
                        preload="none"
                        autoplay="true"
                        playsinline
                    ></video>
                    <div class="close" @click="videoshow = false"></div>
                </div> -->

                <div v-if="videoshow" class="indexflex">
                    <!-- <d-player
                        ref="player"
                        id="player"
                        :options="options"
                        style="width: 415rem;height: 388rem; "
                    ></d-player> -->
                    <video
                        :src="indexabout[0].videoUrl"
                        id="videoRef"
                        controls
                        controlslist="nodownload"
                        width="415rem"
                        height="388rem;"
                        style="object-fit: fill; width: 513rem; height: 377rem"></video>
                    <div class="close" @click="videoshow = false"></div>
                </div>
            </div>

            <div>
                <div class="himg">
                    <img
                        @click="videoshow = true"
                        v-if="indexabout[0]"
                        :src="indexabout[0].address"
                        style="width: 450rem; height: 280rem; position: absolute" />
                    <div @click="videoshow = true" class="playimg"></div>
                </div>
                <div style="position: relative; bottom: 50%; padding-bottom: 56.25%">
                    <img
                        v-if="indexabout[0]"
                        :src="indexabout[0].imgUrl"
                        style="width: 390rem; height: 234rem; position: absolute" />
                </div>
            </div>
            <div class="jianjie">
                <div class="smtitle">Group profile</div>
                <div class="bigtitle">集团简介</div>
                <div class="berich" v-if="indexabout[0]" v-html="indexabout[0].detail"></div>
                <router-link to="/details">
                    <div class="btns" style="background-color: #0e6eb8; position: absolute">
                        查看更多
                        <div style="position: relative; right: -6%; top: 3%">
                            <img src="../../static/images/link.png" alt="" />
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="video2" style="position: relative; margin-bottom: 75rem">
            <!-- <div>
                <div v-if="videoshow" class="indexflex">
                    <video
                        :src="  indexabout[0].videoUrl"
                        id="videoRef"
                        controls
                        controlslist="nodownload"
                        width="415rem"
                        height="388rem;"
                        style="object-fit: fill;width: 415rem;;height: 389rem;"
                    ></video>
                    <div class="close" @click="videoshow = false"></div>
                </div>
            </div> -->

            <!-- <div> -->
            <!-- <div class="himg">
                <img
                    @click="videoshow = true"
                    v-if="indexabout[0]"
                    :src="  indexabout[0].address"
                    style="width:100%;height: 100%;"
                />
                <div @click="videoshow = true" class="playimg"></div>
            </div>
            <img v-if="indexabout[0]" :src="  indexabout[0].imgUrl" style="width:100%;height: 100%;" /> -->

            <div class="new_new_img">
                <img
                    @click="videoshow = true"
                    v-if="indexabout[0]"
                    :src="indexabout[0].address"
                    style="width: 100%; height: 100%" />
                <div @click="videoshow = true" class="playimg"></div>
            </div>
            <img v-if="indexabout[0]" :src="indexabout[0].imgUrl" class="play" />
            <div v-if="videoshow" class="indexflex">
                <video
                    :src="indexabout[0].videoUrl"
                    id="videoRef"
                    controls
                    controlslist="nodownload"
                    width="415rem"
                    height="388rem;"
                    style="object-fit: fill; width: 100%; height: 420rem"></video>
                <div class="close" @click="videoshow = false"></div>
            </div>
            <!-- </div> -->
            <div class="mobile_main">
                <div class="smtitle">Group profile</div>
                <div class="bigtitle2">
                    <div>集团简介</div>
                    <div style="display: flex; align-items: center; line-height: 10rem; font-weight: 100">
                        <router-link to="/details">
                            <div class="btns2" style="background-color: #0e6eb8; position: ; /*absolute;*/">
                                查看更多
                                <div style="/*position:relative; right:-6%; top:3%;*/">
                                    <img src="../../static/images/link.png" alt="" />
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="berich2" v-if="indexabout[0]" v-html="indexabout[0].detail"></div>
                <!-- <router-link to="/details">
                    <div class="btns" style="background-color:#0E6EB8; position:absolute;">
                        查看更多
                        <div style="position:relative; right:-6%; top:3%;">
                            <img src="../../static/images/link.png" alt="" />
                        </div>
                    </div>
                </router-link>
                <div class="berich" v-if="indexabout[0]">
                    {{ indexabout[0].contents }}
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import index from '@/components/index';
import business from '@/components/business';
import boutique from '@/components/boutique';
// import { getindex } from '@/api/api';
// import { getindexabout } from '@/api/api';
import { getnewindex } from '@/api/api';
import 'video.js/dist/video-js.css';

import { videoPlayer } from 'vue-video-player';
import Vue from 'vue';

import VueDPlayer from 'vue-dplayer';
import 'vue-dplayer/dist/vue-dplayer.css';
Vue.use(VueDPlayer);
export default {
    inject: ['reload'],
    components: {
        videoPlayer,
    },
    data() {
        return {
            result: 0,
            headerNav: [
                {
                    name: '企业简介',
                },
                {
                    name: '业务范围',
                },
                {
                    name: '精品工程',
                },
            ],
            isRouterAlive: true,
            golaburl: 'http://39.101.74.19:8717/base-admin',
            videourl: 'http://vfx.mtime.cn/Video/2019/02/04/mp4/190204084208765161.mp4',
            videoshow: false,
            aboutinfo: {},
            datainfo: [],
            indexabout: [],
            ascription: 'companyProfile',
            options: {
                container: document.getElementById('dplayer'), //播放器容器
                mutex: false, //  防止同时播放多个用户，在该用户开始播放时暂停其他用户
                theme: '#b7daff', // 风格颜色，例如播放条，音量条的颜色
                loop: false, // 是否自动循环
                lang: 'zh-cn', // 语言，'en', 'zh-cn', 'zh-tw'
                // screenshot: false, // 是否允许截图（按钮），点击可以自动将截图下载到本地
                hotkey: true, // 是否支持热键，调节音量，播放，暂停等
                preload: 'auto', // 自动预加载
                volume: 0.7, // 初始化音量
                playbackSpeed: [0.5, 0.75, 1, 1.25, 1.5, 2, 3], //可选的播放速度，可自定义
                autoplay: true,
                video: {
                    // url: 'https://www.zjzhongtian.com/upload/2022/06/01/1654048426185470j1j.mp4', // 播放视频的路径
                    url: '', // 播放视频的路径
                    defaultQuality: 0, // 默认是高清
                    // pic: 'http://39.101.74.19:8717/base-admin/img/1dff2bc881564d139415e8a9d61d1ae2.png', // 视频封面图片
                },
            },
        };
    },
    components: {
        index,
        business,
        boutique,
    },
    created() {
        this.result = this.$route.query.result;
    },
    watch: {
        $route: function () {
            this.result = this.$route.query.result;
        },
    },
    mounted() {
        // this.getinfo();
        // this.getabout();
        this.getNewIndex();

        // this.$nextTick(() => {
        //     this.$nextTick(() => {
        //         // // console.log('执行了==');
        //         window.scrollTo(0, 970);
        //     });
        // });
        // window.onload = function() {
        //     // // console.log('执行了==');
        //     window.scrollTo(0, 870);
        // };
        // $(document).ready(function() {
        //     // // console.log('执行了2==');
        //     window.scrollTo(0, 870);
        // });
        // this.$nextTick(() => {
        //     this.goAnchor(window.location.hash);
        // });
    },
    methods: {
        Navclick(index) {
            this.result = index;
        },
        goAnchor(selector) {
            let anchor = this.$el.querySelector(selector);
            document.documentElement.scrollTop = anchor.offsetTop;
        },
        goindex() {
            this.$router.push('/');
        },
        goabout() {
            this.$router.push('/aboutus');
        },
        godetails(data) {
            this.$router.push({ path: '/details', query: { type: data } });
        },
        goboutique() {
            this.$router.push('/boutique');
        },
        // 分组
        group(array, subGroupLength) {
            let index = 0;
            let newArray = [];
            while (index < array.length) {
                newArray.push(array.slice(index, (index += subGroupLength)));
            }
            return newArray;
        },
        // 获取数据
        async getNewIndex() {
            const res = await getnewindex(this.ascription, 1, 99);
            // // console.log(666666666);
            if (res.code == 200) {
                // // console.log('resres1111===', res);
                this.indexabout = res.data;
                console.log('this.indexabout: ', this.indexabout);
                // this.options.video.url = 'this.golaburl' + this.indexabout.videoUrl;
                // // // console.log('this.options.video.url===', this.options.video.url);
                // this.options.logo = this.indexabout.address;
                // // console.log('res===', res);
                // // console.log('this.indexabout===', this.indexabout);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.top_nav2 {
    display: none;
}
.indexflex {
    position: absolute;
    z-index: 100;
    top: -100rem;
    left: 296rem;
}
// @media screen and (max-width: 1440rem) {
//     .video .jianjie {
//         margin-left: 200rem !important;
//     }
// }
// @media (min-width: 768rem) and (max-width: 979rem) {
//     >>> .berich {
//         color: rgba(101, 101, 101, 1) !important;
//         font-size: 14rem !important;
//         height: 300rem !important;
//         margin-top: 15rem !important;
//         overflow: hidden !important;
//         line-height: 61rem !important;
//         text-overflow: ellipsis !important;
//         display: -webkit-box !important;
//         -webkit-line-clamp: 5 !important;
//         line-clamp: 6 !important;
//         -webkit-box-orient: vertical !important;
//     }
//     >>> .video {
//         display: flex !important;
//         margin-top: 190rem !important;
//         flex-direction: column !important;
//         align-items: center !important;
//     }
//     >>> .video > div:nth-child(3) {
//         width: 615rem !important;
//         height: 253rem !important;
//         margin-left: 90rem !important;
//         position: relative !important;
//         display: flex !important;
//         flex-direction: column !important;
//         justify-content: center !important;
//     }
//     >>> .btns {
//         /* width: 150rem; */
//         width: 29% !important;
//         height: 82rem !important;
//         /* line-height: 86rem; */
//         color: #fff !important;
//         font-size: 16rem !important;
//         text-align: center !important;
//         background: rgba(73, 87, 194, 1);
//         border-radius: 5rem !important;
//         position: absolute !important;
//         left: 0 !important;
//         bottom: -60rem !important;
//         cursor: pointer !important;
//         display: flex !important;
//         align-items: center !important;
//         justify-content: center !important;
//     }
//     >>> .indexflex {
//         position: absolute !important;
//         z-index: 100 !important;
//         top: -100rem !important;
//         left: 34% !important;
//     }
// }

// @media screen and (max-width: 1200rem) {
//     >>> .berich {
//         color: rgba(101, 101, 101, 1);
//         font-size: 14rem;
//         height: 300rem;
//         margin-top: 15rem;
//         overflow: hidden;
//         line-height: 61rem;
//         text-overflow: ellipsis;
//         display: -webkit-box;
//         -webkit-line-clamp: 5;
//         line-clamp: 6;
//         -webkit-box-orient: vertical;
//     }
//     >>> .video {
//         display: flex;
//         margin-top: 190rem;
//         flex-direction: column;
//         align-items: center;
//     }
//     >>> .video > div :nth-child(3) {
//         width: 615rem;
//         height: 253rem;
//         margin-left: 90rem;
//         position: relative;
//         display: flex;
//         flex-direction: column;
//     }
//     >>> .btns {
//         /* width: 150rem; */
//         width: 29%;
//         height: 82rem;
//         /* line-height: 86rem; */
//         color: #fff;
//         font-size: 16rem;
//         text-align: center;
//         background: rgba(73, 87, 194, 1);
//         border-radius: 5rem;
//         position: absolute;
//         left: 0;
//         bottom: -86rem;
//         cursor: pointer;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//     }
//     >>> .indexflex {
//         position: absolute;
//         z-index: 100;
//         top: -100rem;
//         left: 34%;
//     }
// }
.video2 {
    display: none;
}
// @media (min-width: 1410px) and (max-width: 1440rem) {
//     .video > div[data-v-5f0f4f8c]:nth-child(3) {
//         margin-left: 5% !important;
//     }
// }
// @media screen and (max-width: 1390rem) {
//     .video > div[data-v-5f0f4f8c]:nth-child(3) {
//         margin-left: 12% !important;
//     }
// }
// @media screen and (max-width: 1400rem) {
//     .btns2 {
//         // width: 19% !important;
//         height: 58rem !important;
//         color: #fff !important;
//         font-size: 20rem !important;
//         text-align: center !important;
//         background: #4957c2;
//         border-radius: 5rem !important;
//         // position: absolute !important;
//         // left: 0 !important;
//         // bottom: -60rem !important;
//         cursor: pointer !important;
//         display: flex !important;
//         align-items: center !important;
//         justify-content: center !important;
//         padding: 0 30rem;
//         > div > img {
//             width: 20rem !important;
//             height: 20rem !important;
//         }
//     }
//     .smtitle {
//         font-size: 16rem !important;
//         margin: 40rem 30rem 0 30rem;
//     }
//     .berich2 {
//         height: 246rem;
//         font-size: 24rem;
//         font-family: Source Han Sans-Regular, Source Han Sans;
//         font-weight: 400;
//         color: #757a7e;
//         line-height: 42rem;
//         display: -webkit-box;
//         overflow: hidden;
//         text-overflow: ellipsis;
//         -webkit-line-clamp: 6;
//         -webkit-box-orient: vertical;
//         margin: 30rem;
//     }
//     .bigtitle2 {
//         font-size: 48rem;
//         color: #333333;
//         display: flex;
//         justify-content: space-between;
//         margin: 30rem;
//         font-weight: bold;
//     }

//     .playimg {
//         position: absolute !important;
//         width: 96rem !important;
//         height: 96rem !important;
//         left: 50% !important;
//         top: 50% !important;
//         transform: translate(-50%, -50%) !important;
//         z-index: 13 !important;
//         background: url('../../static/images/play.png') no-repeat;
//         background-size: 100% 100%;
//         cursor: pointer;
//     }

//     .video {
//         display: flex !important;
//         margin-top: 190rem !important;
//         flex-direction: column !important;
//         align-items: center !important;
//         display: none !important;
//     }
//     .indexflex {
//         position: absolute !important;
//         z-index: 100 !important;
//         top: 0% !important;
//         left: 0% !important;
//         width: 100% !important;
//     }
//     .close[data-v-5f0f4f8c] {
//         width: 40rem !important;
//         height: 40rem !important;
//         background: url(https://www.zjzhongtian.com/bocweb/web/css/../img/close-vid2.png) no-repeat center/100% auto !important;
//         position: absolute !important;
//         top: 4% !important;
//         right: 4% !important;
//         cursor: pointer !important;
//     }
//     .mobile_main {
//         margin-top: 30rem !important;
//     }
//     .video2 {
//         // display: flex !important;
//         margin-top: 190rem !important;
//         // flex-direction: column !important;
//         // align-items: center !important;
//         display: block !important;
//     }
//     .new_new_img {
//         position: relative !important;
//         height: 388rem !important;
//         margin: 30rem;
//     }
//     .play {
//         position: absolute !important;
//         width: 85% !important;
//         height: 320rem !important;
//         top: 13% !important;
//         left: 8% !important;
//         z-index: -1 !important;
//     }
//     .himg {
//         position: absolute !important;
//         top: 0 !important;
//         left: 0 !important;
//         z-index: 2 !important;
//         width: 100% !important;
//         height: 388rem !important;
//     }
//     .top_nav2 {
//         background-color: #f4f4f4 !important;
//         height: 96rem !important;
//         display: flex !important;
//         justify-content: center !important;
//         cursor: pointer !important;
//         width: 100% !important;
//         // display: block !important;
//     }
//     .top_nav {
//         background-color: #f4f4f4 !important;
//         height: 96rem !important;
//         display: flex !important;
//         justify-content: center !important;
//         cursor: pointer !important;
//         width: 100% !important;
//         display: none !important;
//     }
//     .nav1 {
//         width: 249rem !important;
//         height: 100% !important;
//         display: flex !important;
//         align-items: center !important;
//         color: #333 !important;
//         font-size: 26rem !important;
//         font-family: Poppins !important;
//         font-weight: bold !important;
//         justify-content: center !important;
//     }
//     .nav2 {
//         width: 249rem !important;
//         height: 100% !important;
//         display: flex !important;
//         align-items: center !important;
//         color: #333 !important;
//         font-size: 26rem !important;
//         font-family: Poppins !important;
//         font-weight: bold !important;
//         justify-content: center !important;
//     }

//     .nav3 {
//         width: 249rem !important;
//         height: 100% !important;
//         display: flex !important;
//         align-items: center !important;
//         color: #333 !important;
//         font-size: 26rem !important;
//         font-family: Poppins !important;
//         font-weight: bold !important;
//         justify-content: center !important;
//     }
// }

.top_nav {
    background-color: #f4f4f4;
    // background-color: #e4e7ed;
    height: 100rem;
    display: flex;
    // align-items: center;
    // font-size: 16rem;
    justify-content: center;
    cursor: pointer;

    >>> .el-tabs__header {
        padding: 0;
        /* position: relative; */
        margin: 0 0 15rem;
        >>> .el-tabs__nav-wrap {
            overflow: hidden;
            margin-bottom: -1rem;
            // position: relative;
        }
    }
}

.nav1 {
    width: 440rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333333;
    font-size: 16rem;
    font-family: Poppins;
    font-weight: bold;
    // line-height: 100rem;
}
.nav1:hover {
    border-bottom: 4rem solid #0e6eb8;
    animation: animate 2s ease-in-out infinite;
    animation-delay: calc(0.1s * var(--i));
    animation-play-state: running;
}
.nav2:hover {
    border-bottom: 4rem solid #0e6eb8;
    animation: animate 2s ease-in-out infinite;
    animation-delay: calc(0.1s * var(--i));
    animation-play-state: running;
}
.nav3:hover {
    border-bottom: 4rem solid #0e6eb8;
    animation: animate 2s ease-in-out infinite;
    animation-delay: calc(0.1s * var(--i));
    animation-play-state: running;
}
@keyframes animate {
    0%,
    40%,
    100% {
        transform: translateY(0);
    }

    20% {
        transform: translateY(-5rem);
    }
}

.nav1 span {
    width: 100%;
    text-align: center;
    border-right: 1rem solid #999999;
}
.nav2 {
    width: 440rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333333;
    font-size: 16rem;
    font-family: Poppins;
    font-weight: bold;
    // line-height: 100rem;
}
.nav2 span {
    width: 100%;
    text-align: center;
    border-right: 1rem solid #999999;
}
.nav3 {
    width: 440rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333333;
    font-size: 16rem;
    font-family: Poppins;
    font-weight: bold;
    // line-height: 100rem;
}
.nav3 span {
    width: 100%;
    text-align: center;
}
.video {
    display: flex;
    justify-content: center;
    margin-top: 190rem;

    .video-fixed {
        position: fixed;
        width: 100%;
        height: 100%;
        background: #000;
        z-index: 9999;
        top: 0;
        left: 0;
        cursor: pointer;
    }
    > div:nth-child(2) {
        width: 415rem;
        height: 388rem;
        position: relative;
        img {
            width: 415rem;
            height: 388rem;
            border-radius: 10rem;
        }
    }
    > div:nth-child(3) {
        width: 615rem;
        margin-left: 90rem;
        position: relative;
    }
}
.video {
    display: flex;
    justify-content: center;
    margin-top: 190rem;

    .video-fixed {
        position: fixed;
        width: 100%;
        height: 100%;
        background: #000;
        z-index: 9999;
        top: 0;
        left: 0;
        cursor: pointer;
    }
    > div:nth-child(2) {
        width: 415rem;
        height: 388rem;
        position: relative;
        img {
            width: 415rem;
            height: 388rem;
            border-radius: 10rem;
        }
    }
    > div:nth-child(3) {
        width: 615rem;
        margin-left: 5%;
        position: relative;
    }
}

.close {
    width: 25rem;
    height: 25rem;
    background: url(https://www.zjzhongtian.com/bocweb/web/css/../img/close-vid2.png) no-repeat center/100% auto;
    position: absolute;
    // top: 20rem;
    // right: 20rem;
    top: 4%;
    right: 4%;
    cursor: pointer;
}

.playimg {
    position: absolute;
    width: 60rem;
    height: 60rem;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 13 !important;
    background: url('../../static/images/play.png') no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
}

.himg {
    position: relative;

    top: -20rem;
    left: -76rem;
    z-index: 2;
    width: 100%;
    padding-bottom: 56.25%;
    img:hover {
        transform: scale(1.1);
        overflow: hidden;
        transition: 0.5s ease-in;
    }
}
.carsty {
    display: flex;
    justify-content: space-between;
}
.zmousel {
    position: relative;
    width: 460rem;
    height: 318rem;
    &:hover > .botmtitle {
        display: block;
        transition: 0.5s ease-in;
    }
}
.botmtitle {
    position: absolute;
    left: 0;
    bottom: 0;
    background: #fff;
    display: none;
    width: 100%;
    padding: 25rem 30rem;
    box-sizing: border-box;

    > :first-child {
        color: rgba(51, 51, 51, 1);
        font-size: 25rem;
    }
    > :nth-child(2) {
        color: rgba(101, 101, 101, 1);
        font-size: 16rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index2.vue